module.exports = __webpack_public_path__ + "static/img/ico23.f90368d0.svg";